<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <!-- 站点选择 -->
        <div class="label">选择站点：</div>
        <Select v-model="search.siteMn" style="width: 7.8em" @on-change="selectDevice($event)" placeholder="请选择设备"
          clearable>
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px">选择设备：</div>
        <Select v-model="search.siteDeviceId" style="width: 7.8em;" placeholder="请选择设备" clearable>
          <Option v-for="item in deviceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <Select v-model="search.timeSegmentation" clearable style="width:100px;margin-left:10px;text-align:center;">
          <Option v-for="item in timeSegmentationList" :key="item.value" :value="item.value">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "车间名称",
            key: "siteName",
            align: "center"
          },
          {
            title: "设备名称",
            key: "siteDeviceName",
            align: "center"
          },
          {
            title: "数值",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  params.row.ai +" "+ this.getUnit(params.row.id)
                ),
              ]);
            }
          },
          {
            title: "状态",
            key: "aiStatusName",
            align: "center"
          },
          {
            title: "日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm")
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null
      },
      UnitMap: new Map(),
      // 查询
      search: {
        siteMn: null,
        siteDeviceId: null,
        findStartCreateDate: new Date().setHours("0"),
        findEndCreateDate: new Date().getTime(),
        timeSegmentation: null
      },
      siteList: [], // 站点枚举列表
      deviceList: [], // 设备枚举
      timeSegmentationList: [
        {
          name: "每分钟",
          value: 60
        },
        {
          name: "每十分钟",
          value: 600
        },
        {
          name: "每小时",
          value: 3600
        }
      ]
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getSiteList(); // 获取站点枚举
    this.getData();
    this.tableInit(); // 表格初始化
    window.addEventListener("resize", this.tableInit);
  },
  methods: {
    getUnit(key) {
      return this.UnitMap.get(key);
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Warn.getWarnAiList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          let list = res.data.list;
          list.forEach(item => {
            this.UnitMap.set(item.id, item.unit);
          });

          this.table.data = list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取站点枚举值
    getSiteList() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取设备
    selectDevice(msg) {
      this.$api.Enum.getDeviceEnum({ content: { mn: msg } }, [
        "uuid",
        "company"
      ]).then(res => {
        if (res.code == 0) {
          this.deviceList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.findStartCreateDate = new Date(date[0]).setHours("0");
      this.search.findEndCreateDate = new Date(date[1]).setHours("24");
    },
    // 表格高度计算
    tableInit() {
      if (this.$route.path != "/chome/warnTable") {
        window.removeEventListener("resize", this.tableInit);
        return false;
      }
      let headerH = emComputed(14.5); // header高度7em加操作栏5.5em转换px， 2em的上下边距分页组件
      this.table.maxHeight = window.innerHeight - headerH - 32; // 32px的分页组件高度
    }
  }
};
</script>